import styled from 'styled-components';

export const MainImage = styled.img`
  width: 100%;
`;
